import { z } from 'zod'

/** 機場物件 Schema */
const airportItemSchema = z.object({
  /** 完整中文名稱 */
  chinese: z.string(),
  /** 顯示標籤（城市-代碼） */
  label: z.string(),
  /** 機場代碼值 */
  value: z.string(),
  /** 地區 */
  region: z.string()
})

/** 長榮航空航班時刻表 Schema */
export const evaFlightSchedulesSchema = z.object({
  /** 機場列表 */
  airports: z.object({
    /** 機場項目陣列 */
    airport: z.array(airportItemSchema)
  })
})

export interface EvaFlightSchedules extends z.infer<
  typeof evaFlightSchedulesSchema
> {}

export interface AirportItem extends z.infer<typeof airportItemSchema> {}
